import { OnDestroy, SimpleChanges, OnChanges } from '@angular/core';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { EntityManagerProvider } from '../providers/entity-manager-provider/entity-manager-provider';
import { AuthenticationService } from '../providers/authentication/authentication.service';

import { TranslateService } from 'ng2-translate';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { Idioma } from '../domain/Idioma';
import { IdiomaService } from '../providers/idioma/idioma.service';
import { NivelFormulario, NivelIdiomaFormulario } from '../domain/NivelFormulario';
import { IdiomaCalendario } from '../domain/IdiomaCalendatio';
import { AppComponent } from '../app.component';


@Component({
	selector: 'app-formulario-nivel',
	templateUrl: './FormularioNivel.component.html',
	providers: [MessageService]
})

export class FormularioNivelComponent implements OnDestroy, OnChanges{ // extends FormGroup { // extends FormularioBaseComponent<ALA> {

	@Input() nivelSeleccionado: any = NivelFormulario;
	@Input() edicion: boolean;

	@Output() onElementoGuardado: EventEmitter<any> = new EventEmitter();
	@Output() onElementoError: EventEmitter<any> = new EventEmitter();
	@Output() onElementoEliminado: EventEmitter<boolean> = new EventEmitter();

	private espacio: any;

	msgs: Message[] = [];
	spinner: HTMLElement;

	/* IDIOMA */
	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;
	idiomaCalendario: IdiomaCalendario;

	public confirmacionVisible = false;
	public operacion = '';

	public fAltaError = false;
	public fBajaError = false;

	constructor(
		private appComponent: AppComponent,
		private entityManager: EntityManagerProvider,
		public authService: AuthenticationService,
		private idiomaService: IdiomaService,
		private translate: TranslateService) {

		const that = this;
		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';

		this.entityManager.getIDIOMA()
		.then(function (idiomasENTIDAD: any) {

			that.idiomas = [];
			idiomasENTIDAD.forEach(idioma => {
				if(idioma.Visible === true){
				that.idiomas.push(new Idioma(idioma));
				}
			});

			that.idiomaDefecto = idiomaService.getIdiomaDefecto(that.idiomas);
			that.idiomaSeleccionado = that.idiomaDefecto;
		});

			this.idiomaCalendario = new IdiomaCalendario();
			this.idiomaCalendario.firstDayOfWeek = 1;
			this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
			this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
			this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
			this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
			this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
			this.idiomaCalendario.today = this.translate.instant('Calendario.today');
			this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.idiomaSeleccionado = this.idiomaDefecto;
		this.confirmacionVisible = false;
		this.onIdiomaChange({value: this.idiomaSeleccionado});
	}

	ngOnDestroy(): void {
		this.entityManager.RejectChanges();
	}

	protected leerFormularioPropio() {
		this.nivelSeleccionado.ESPACIO = this.espacio;
		this.nivelSeleccionado.idEspacio = this.authService.getIdEspacio();
		return this.nivelSeleccionado;
	}

	public setNivelSeleccionado(nivel: any) {
		this.nivelSeleccionado = nivel;
	}

	/* ************************************************************************** */
	/*                            COMUN FORMULARIO                                */
	/* ************************************************************************** */

	/*  */
	inputChanged(value) {
		//  Cojemos la traduccion del espacio al idioma seleccionado
		const espacioIdioma = this.nivelSeleccionado.Idiomas.get(this.idiomaSeleccionado.ENTIDAD.Codigo);

		// Guardamos los posibles cambios del idioma
		espacioIdioma.Nombre = this.nivelSeleccionado.Nombre;
		espacioIdioma.Descripcion = this.nivelSeleccionado.Descripcion;
		espacioIdioma.NombreCorto = this.nivelSeleccionado.NombreCorto;
		this.nivelSeleccionado.Idiomas.set(this.idiomaSeleccionado.ENTIDAD.Codigo, espacioIdioma);

		const p1Error = this.nivelSeleccionado.FechaAlta === undefined || this.nivelSeleccionado.FechaAlta === null || this.nivelSeleccionado.FechaAlta === '';
		const p2Error = false; // this.rutaSeleccionada.FechaBaja === ''  || this.rutaSeleccionada.FechaBaja === undefined  || this.rutaSeleccionada.FechaBaja === null

		// validacion al editar fecha_alta
		if (value === 'fecha_alta'){
			if (p1Error) {
				this.fAltaError = true;
			}
			else {
				this.fAltaError = false;
			}
		}
		// validacion al editar fecha_baja
		else if (value === 'fecha_baja'){
			if (p2Error) {
				this.fBajaError = true;
			}
			else {
				this.fBajaError = false;
			}
		}
	}

	public esEdicion(): boolean {
		return this.edicion;
	}

	public validar(): boolean {
		console.warn('Implementar: validar');
		const p1 = this.fAltaError;

		if (p1) {
			this.msgs.push({ severity: 'error',  detail: this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO') });
			return false;
		}
		else {
			return true;
		}
	}

	/* Confirmacion */
	mostrarConfirmacion(operacion) {
		this.appComponent.showWarn(operacion);
		this.operacion = operacion;
		this.confirmacionVisible = true;
	}

	confirmar() {
		this.confirmacionVisible = false;
		this.msgs = [];
		if (this.operacion === 'guardar') {
			this.guardar();
		}

	}

	cancelar() {
		this.msgs = [];
		this.operacion = '';
		this.confirmacionVisible = false;
	}

	public guardar(): any {
		if (this.validar()) {

			this.spinner.style.display = 'inherit';

			if (!this.esEdicion()) {
				return this.guardarNuevo();
			}
			else {
				this.guardarEdicion();
			}
		} else {
			console.log(this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO'));
		}
	}

	protected guardarNuevo = () => {
		const that = this;
		return this.entityManager.newNIVEL()
		.then(function (oNivel) {
			const idEspacio = that.authService.getIdEspacio();

			oNivel.IDIOMAS.forEach(ESPACIO_IDIOMA => {
				const aux = that.nivelSeleccionado.Idiomas.get(ESPACIO_IDIOMA.IDIOMA.Codigo);
				if(aux){
					ESPACIO_IDIOMA.Nombre = aux.Nombre;
					ESPACIO_IDIOMA.Descripcion = aux.Descripcion;
				}
				else{
					const espacioIdioma = that.nivelSeleccionado.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
					if(espacioIdioma){
						ESPACIO_IDIOMA.Nombre = espacioIdioma.Nombre ? espacioIdioma.Nombre : '';
						ESPACIO_IDIOMA.Descripcion = espacioIdioma.Descripcion ? espacioIdioma.Descripcion : '';
					}
				}
			});

			const espacioIdioma = that.nivelSeleccionado.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
			that.nivelSeleccionado.Nombre = espacioIdioma.Nombre ? espacioIdioma.Nombre : '';
			that.nivelSeleccionado.Descripcion = espacioIdioma.Descripcion ? espacioIdioma.Descripcion : '';

			oNivel.IdEspacio = idEspacio;
			oNivel.Nombre = that.nivelSeleccionado.Nombre;
			oNivel.Descripcion = that.nivelSeleccionado.Descripcion;
			oNivel.NivelVertical = that.nivelSeleccionado.NivelVertical;
			oNivel.NombreCorto = that.nivelSeleccionado.NombreCorto;
			oNivel.FechaAlta = that.nivelSeleccionado.FechaAlta;
			oNivel.FechaBaja = that.nivelSeleccionado.FechaBaja;

			that.nivelSeleccionado = oNivel;
			return that.entityManager.getEspacioById(idEspacio);
		})
		.then(function (espacio) {
			that.espacio = espacio;
			that.nivelSeleccionado.ESPACIO = that.espacio;
			return that.entityManager.saveChanges();
		})
		.then(function(data: any) {
			console.log(data)
			// Renovamos el Token
			if(data.httpResponse.status === 200){
				that.authService.relogin();
			}
		})
		.then(function () {
			that.onElementoGuardado.emit(that.nivelSeleccionado);
		})
		.catch(function (e) {
			that.onElementoError.emit(that.nivelSeleccionado);
			that.spinner.style.display = 'none';
		});

	}

	protected guardarEdicion = () => {
		const that = this;

		this.guardarMultiIdioma()
		.then(function () {
			const espacioIdioma = that.nivelSeleccionado.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
			that.nivelSeleccionado.Nombre = espacioIdioma.Nombre ? espacioIdioma.Nombre : '';
			that.nivelSeleccionado.Descripcion = espacioIdioma.Descripcion ? espacioIdioma.Descripcion : '';

			that.nivelSeleccionado.FechaAlta = that.nivelSeleccionado.FechaAlta;
			that.nivelSeleccionado.FechaBaja = that.nivelSeleccionado.FechaBaja;
			that.nivelSeleccionado.NombreCorto = that.nivelSeleccionado.NombreCorto;

			return that.entityManager.saveChanges();
		})
		.then(function(data: any) {
			console.log(data)
			// Renovamos el Token
			if(data.httpResponse.status === 200){
				that.authService.relogin();
			}
		})
		.then(function () {
			that.onElementoGuardado.emit(that.nivelSeleccionado);
		})
		.catch(function (e) {
			that.onElementoError.emit(that.nivelSeleccionado);
			that.spinner.style.display = 'none';
		});
	}

	guardarMultiIdioma(){
		const that = this;
		this.entityManager.deleteEntityArray(this.nivelSeleccionado.IDIOMAS);

		return this.entityManager.newNIVEL_IDIOMA(this.nivelSeleccionado)
		.then(function(NIVEL_IDIOMAs){

			NIVEL_IDIOMAs.forEach(NIVEL_IDIOMA => {
				const aux = that.nivelSeleccionado.Idiomas.get(NIVEL_IDIOMA.IDIOMA.Codigo);
				if (aux) {
					NIVEL_IDIOMA.Nombre = aux.Nombre;
					NIVEL_IDIOMA.Descripcion = aux.Descripcion;
				}

			});
		});
	}

	/* App-Selector_Idioma */
	onIdiomaChange($event) {
		const idioma = $event.value;
		if (!idioma) {
			return;
		}
		if (!this.nivelSeleccionado || !this.nivelSeleccionado.Idiomas) {
			return;
		}
		this.idiomaSeleccionado = idioma;

		// Cojemos la traduccion del espacio al idioma seleccionado
		let espacioIdioma = this.nivelSeleccionado.Idiomas.get(idioma.value);

		// Si no existe la creamos
		if (!espacioIdioma) {

			espacioIdioma = new NivelIdiomaFormulario();

			this.nivelSeleccionado.Idiomas.set(idioma.value, espacioIdioma);

		}

		// Seteamos los valores de espacioFormulario con los valores del idioma seleccionado
		this.nivelSeleccionado.Nombre = espacioIdioma.Nombre;
		this.nivelSeleccionado.Descripcion = espacioIdioma.Descripcion;

		console.log('Cambiar Titulo y descripcion a la del idioma: ' + idioma.value + '(' + idioma.title + ')');
	}

	onFechaAceptar(dt, calendar, columna, tipo) {
		console.log(calendar);
		const fecha = calendar.value ? calendar.value : new Date();
		if (tipo === 'FechaAlta') {
			this.nivelSeleccionado.FechaAlta = fecha;
		}
		if (tipo === 'FechaBaja') {
			this.nivelSeleccionado.FechaBaja = fecha;
		}
		calendar.overlayVisible=false;
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/formularios/FormularioNivel.component.ts